import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Icon from 'components/design-system/Icon'

const highlightSx = {
  backgroundImage: 'linear-gradient(to top, var(--color-blue-500), var(--color-cyan-600))', // Gradient/Button Regular
  color: 'var(--color-icon-strong)'
}

/**
 * Nav Item (Figma 8:9700): 32×32, không nền mặc định; hover/active dùng gradient Button Regular, icon Secondary → Putih.
 * `icon` là tên icon trong registry `assets/icons` (vd. "database"), tô bằng `currentColor`. Có thể truyền `children` thay cho `icon`.
 */
const NavItem = React.forwardRef(({ icon, active = false, iconColor, children, sx, ...props }, ref) => (
  <Box
    ref={ref}
    component="button"
    type="button"
    aria-current={active ? 'page' : undefined}
    sx={[
      {
        position: 'relative',
        flexShrink: 0,
        width: 32,
        height: 32,
        p: 'var(--space-4)',
        m: 0,
        border: 0,
        borderRadius: 'var(--radius-md)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        color: iconColor ?? 'var(--color-icon-default)',
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': highlightSx,
        '&:focus-visible': { outline: '2px solid var(--color-border-focus)', outlineOffset: '2px' }
      },
      active && highlightSx,
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
    {...props}
  >
    {icon ? (
      <Icon name={icon} />
    ) : (
      children
    )}
  </Box>
))

NavItem.displayName = 'NavItem'

NavItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  iconColor: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default NavItem
